var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"no-one-selected"},[_c('div',{staticClass:"smile-wrapper"},[_c('span',{staticClass:"smile"},[_vm._v(":(")])]),_c('div',{staticClass:"text-wrapper"},[_c('span',{staticClass:"text"},[_vm._v("Выберите хотя бы одного клиента, иначе режим пакетной обработки не сработает")])])])
}]

export { render, staticRenderFns }